import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Link } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ResourcesPage = () => {
  const resources = [
    {
      title: 'Министерство просвещения РФ',
      description: 'Официальный сайт Министерства просвещения Российской Федерации',
      url: 'https://edu.gov.ru/',
      icon: '🏛️',
    },
    {
      title: 'Федеральный портал «Российское образование»',
      description: 'Единое окно доступа к образовательным ресурсам',
      url: 'http://www.edu.ru/',
      icon: '📚',
    },
    {
      title: 'Растим детей',
      description: 'Навигатор для современных родителей',
      url: 'https://растимдетей.рф/',
      icon: '👨‍👩‍👧‍👦',
    },
    {
      title: 'Управление образования Краснодара',
      description: 'Департамент образования администрации МО г. Краснодар',
      url: 'https://uo.krd.ru/',
      icon: '🏫',
    },
    {
      title: 'Портал психологических услуг',
      description: 'Консультации психологов онлайн',
      url: '#',
      icon: '🧠',
    },
    {
      title: 'Методические материалы для родителей',
      description: 'Полезные статьи и рекомендации',
      url: '#',
      icon: '📖',
    },
  ];

  return (
    <>
      <Header />
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <LinkIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography
            variant="h2"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: 'primary.main',
            }}
          >
            Полезные ресурсы
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Образовательные порталы и информационные ресурсы
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {resources.map((resource, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                component={Link}
                href={resource.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  height: '100%',
                  textDecoration: 'none',
                  borderRadius: 4,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Typography variant="h2" sx={{ mr: 2 }}>
                      {resource.icon}
                    </Typography>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>
                          {resource.title}
                        </Typography>
                        <OpenInNewIcon sx={{ ml: 1, fontSize: 18, color: 'text.secondary' }} />
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {resource.description}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            mt: 6,
            p: 4,
            backgroundColor: 'rgba(0, 172, 193, 0.08)',
            borderRadius: 4,
            borderLeft: '4px solid #00ACC1',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            📌 Важная информация
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
            Если вы знаете полезные ресурсы для родителей, которые можно добавить в этот раздел,
            пожалуйста, сообщите нам по электронной почте{' '}
            <strong>wonderland_2023@mail.ru</strong>
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default ResourcesPage;
